import script from "./DurationWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./DurationWindow.vue?vue&type=script&setup=true&lang=js"

import "./DurationWindow.vue?vue&type=style&index=0&id=f8004f8e&scoped=true&lang=css"

import exportComponent from "/home/interact/webapp/4.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8004f8e"]])

export default __exports__